import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";

import icon1 from '../../../theme/assets/other/tc_cab_pre_sale_stat_icon1.png';
import icon2 from '../../../theme/assets/other/tc_cab_pre_sale_stat_icon2.png';
import icon3 from '../../../theme/assets/other/tc_cab_pre_sale_stat_icon3.png';
import CabinetHello from "../../_UI/cabinetHello";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

const CabinetPreSaleStatistic = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const preSaleMain = useSelector(store => store.cabinet.preSaleMainStatus);

    const sold = Number(preSaleMain?.token_sale?.sold || 0);
    const totalSupply = Number(preSaleMain?.token_sale?.total_supply || 0);

    const soldPercentRaw = totalSupply > 0 ? (sold / totalSupply) * 100 : 0;

    const soldPercent =
        soldPercentRaw > 0 && soldPercentRaw < 0.001
            ? "< 0.001"
            : Number(soldPercentRaw.toFixed(3)).toString();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.noteWrap}`}>
                <CabinetHello
                    title={t('Добро пожаловать в pre-sale time capsule!')}
                    description={t('Здесь будет вы можете купить токены проекта и стать частью цифровой вселенной!')}
                />
            </div>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC} ${Styles.perspective3dXl}`}>
                <div className={`${Styles.contentWrapItem} ${Styles.perspective3dXl}`}>
                    <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl} ${Styles.rotate3dBottomXl}`}>
                        <div className={`${Styles.cardBox}`}>
                            <div className={`${Styles.cardBoxIconWrap}`}>
                                <img src={icon1} alt=""/>
                            </div>
                            <div className={`${Styles.cardBoxTitle}`}>{t('Pre-Sale цена токена')} ${preSaleMain?.token_sale?.token_code || ''}</div>
                            <div className={`${Styles.cardBoxValue}`}>1 ${preSaleMain?.token_sale?.token_code || ''} = {preSaleMain?.token_sale?.price * 1 || ''}USDT</div>
                            <div className={`${Styles.cardBoxNote}`} onClick={()=>{navigate('/tokenomics')}}>{t('Подробнее')}</div>
                        </div>
                    </div>
                </div>
                <div className={`${Styles.contentWrapItem} ${Styles.perspective3dXl}`}>
                    <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl} ${Styles.rotate3dBottomXl}`}>
                        <div className={`${Styles.cardBox}`}>
                            <div className={`${Styles.cardBoxIconWrap}`}>
                                <img src={icon2} alt=""/>
                            </div>
                            <div className={`${Styles.cardBoxTitle}`}>{t('Продано токенов')}</div>
                            <div className={`${Styles.cardBoxValue}`}>{preSaleMain?.token_sale?.sold || ''} ${preSaleMain?.token_sale?.token_code || ''}</div>
                            <div className={`${Styles.cardBoxNote} ${Styles.cardBoxNoteM}`}>{soldPercent}% {t('из')} 100%</div>
                            <div className={`${Styles.cardBoxNote} ${Styles.cardBoxNoteD}`}>{soldPercent}% {t('от общего объема')}</div>
                        </div>
                    </div>
                </div>
                <div className={`${Styles.contentWrapItem} ${Styles.perspective3dXl}`}>
                    <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl} ${Styles.rotate3dBottomXl}`}>
                        <div className={`${Styles.cardBox}`}>
                            <div className={`${Styles.cardBoxIconWrap}`}>
                                <img src={icon3} alt=""/>
                            </div>
                            <div className={`${Styles.cardBoxTitle} ${Styles.cardBoxTitleM}`}>{t('Участников')}</div>
                            <div className={`${Styles.cardBoxTitle} ${Styles.cardBoxTitleD}`}>{t('Всего участников')}</div>
                            <div className={`${Styles.cardBoxValue}`}>{preSaleMain?.token_sale?.participants || ''}</div>
                            <div className={`${Styles.cardBoxNote}`}>+{preSaleMain?.token_sale?.participants_24h} {t('за')} 24{t('ч')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetPreSaleStatistic;